// extracted by mini-css-extract-plugin
export default {"control":"SearchControl_control__80X20"};